import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import StepBlock from './step-block'
import styles from './style.scss'
import TTBH_STEP from './const'

const TTBStep = ({ reference }) => (
  <Fragment>
    <style jsx>{styles}</style>
    <div className="ttb-step__wrapper" ref={reference}>
      {TTBH_STEP.map((stepData) => (
        <StepBlock stepData={stepData} />
      ))}
    </div>
  </Fragment>
)

TTBStep.propTypes = {
  reference: PropTypes.func.isRequired,
}

export default TTBStep
